'use client';

import type {MyList} from 'server/apiHandlers/getMyListsHandler';
import ListMapSideContent from './ListMapSideContent';
import {useFilteredPlaces} from './useFilteredPlaces';
import {useMapResize} from './useMapUtils';
import MapLayout from './MapLayout';
import useMap from './useMap';

const emptyArray: Review[] = [];

type Props = {
  topPlaces: Place[];
  myLists: MyList[];
  countryName: string;
  session: IronSession | null;
};

const TopPlacesMapContent = ({topPlaces, myLists, countryName, session}: Props) => {
  const filteredPlaces = useFilteredPlaces(topPlaces);

  const {mapContainer, map} = useMap({variant: 'places', places: filteredPlaces});

  useMapResize(mapContainer, map);

  return (
    <MapLayout
      map={map}
      session={session}
      places={topPlaces}
      reviews={emptyArray}
      myLists={myLists}
      mapContainer={mapContainer}
      listName={countryName ? `Top places in ${countryName}` : 'Top places'}
    >
      <ListMapSideContent places={topPlaces} reviews={emptyArray} map={map} />
    </MapLayout>
  );
};

export default TopPlacesMapContent;
